import { date } from '@/lib/date';
import type { Event } from 'generated/prisma/browser';
import { capitalize } from 'lodash';

export const RETREAT_PLACE = 'Jardim da Auxiliadora';
export const RETREAT_PLACE_DETAIL =
  "Santo Antônio do Sapezeiro, Santa Bárbara d'Oeste - SP";

/** Textos do site derivados do próximo encontro (com datas do design como fallback). */
export function retreatInfo(event?: Pick<Event, 'startDate' | 'endDate'> | null) {
  if (!event) {
    return {
      hasEvent: false,
      start: null,
      rangeLong: 'em breve',
      whenTitle: 'Em breve',
      whenSub: 'Datas a confirmar',
      weekdays: '',
      year: null,
      monthYear: 'EM BREVE',
      days: 'em breve',
    };
  }

  const a = date(event.startDate);
  const b = date(event.endDate);
  const sameMonth = a.month() === b.month();
  const days = sameMonth
    ? `${a.format('DD')} e ${b.format('DD')} de ${b.format('MMMM')}`
    : `${a.format('DD')} de ${a.format('MMMM')} a ${b.format('DD')} de ${b.format('MMMM')}`;
  const weekdays = a.isSame(b, 'day')
    ? capitalize(a.format('dddd'))
    : `${capitalize(a.format('dddd'))} e ${b.format('dddd')}`;

  return {
    hasEvent: true,
    start: a.hour(8).minute(0).second(0),
    /** "07 e 08 de novembro de 2026" */
    rangeLong: `${days} de ${b.year()}`,
    /** "07 e 08 de Novembro" */
    whenTitle: sameMonth
      ? `${a.format('DD')} e ${b.format('DD')} de ${capitalize(b.format('MMMM'))}`
      : `${a.format('DD')} de ${capitalize(a.format('MMMM'))} a ${b.format('DD')} de ${capitalize(b.format('MMMM'))}`,
    /** "Sábado e domingo, 2026" */
    whenSub: `${weekdays}, ${b.year()}`,
    weekdays,
    year: b.year(),
    /** "NOVEMBRO 2026" */
    monthYear: `${a.format('MMMM').toUpperCase()} ${a.year()}`,
    /** "07 e 08 de novembro" */
    days,
  };
}
